/** Badge only at the hotel's department; mobile has no department so always show. */
export function shouldShowTireHotelBadge(
  hotelServiceDepartmentId: number | null | undefined,
  bookingServiceDepartmentId?: number
): boolean {
  return (
    bookingServiceDepartmentId == null ||
    hotelServiceDepartmentId == null ||
    hotelServiceDepartmentId === bookingServiceDepartmentId
  );
}

/** Adapter field first; otherwise a customer hotel at a different department. */
export function tireHotelOtherDepartmentId(args: {
  bookableServicesOtherDepartmentId?: number | null;
  hotelServiceDepartmentId?: number | null;
  bookingServiceDepartmentId?: number | null;
}): number | undefined {
  if (args.bookableServicesOtherDepartmentId != null) {
    return args.bookableServicesOtherDepartmentId;
  }
  if (args.hotelServiceDepartmentId != null && args.hotelServiceDepartmentId !== args.bookingServiceDepartmentId) {
    return args.hotelServiceDepartmentId;
  }
  return undefined;
}
